<div
  class="grid-layout-container"
  [style.grid-auto-flow]="order === gridLayoutOrder.ROW ? 'row' : 'column'"
  [style.grid-template-rows]="order === gridLayoutOrder.ROW ? 'unset' : 'repeat(' + numberOfRows + ', 1fr)'"
  [style.grid-template-columns]="order === gridLayoutOrder.ROW ? 'repeat(' + columns + ', 1fr)' : 'unset'"
>
  <ng-content></ng-content>
</div>